import api from './api';

const API_PREFIX = "api/trend-mapping-group";

/**
 * Get all trend mapping groups for a specific account and card
 * Groups are now account-wise and card-wise (not page-wise)
 * @param {Object} params - Query parameters
 * @param {string} params.cardId - Card ID (e.g., INSURANCE_DATA, DOCTOR_DATA)
 * @returns {Promise} API response
 */
const getTrendMappingGroups = async (params) => {
    const response = await api.get(API_PREFIX, { params });
    return response;
};

/**
 * Create a new trend mapping group
 * Groups are now account-wise and card-wise (not page-wise)
 * @param {Object} body - Group data
 * @param {string} body.name - Group name
 * @param {string} body.cardId - Card ID
 * @param {string[]} body.itemIds - Array of item IDs
 * @returns {Promise} API response
 */
const createTrendMappingGroup = async (body) => {
    const response = await api.post(API_PREFIX, body);
    return response;
};

/**
 * Update an existing trend mapping group
 * @param {string} id - Group ID
 * @param {Object} body - Updated group data
 * @returns {Promise} API response
 */
const updateTrendMappingGroup = async (id, body) => {
    const response = await api.put(`${API_PREFIX}/${id}`, body);
    return response;
};

/**
 * Delete a trend mapping group
 * @param {string} id - Group ID
 * @returns {Promise} API response
 */
const deleteTrendMappingGroup = async (id) => {
    const response = await api.delete(`${API_PREFIX}/${id}`);
    return response;
};

export {
    getTrendMappingGroups,
    createTrendMappingGroup,
    updateTrendMappingGroup,
    deleteTrendMappingGroup,
};

